import styled from 'styled-components';

const Divider = styled.div<{
  height?: string;
  color?: string;
  isVisible?: boolean;
  margin?: string;
}>`
  width: 100%;
  ${({ height = '1px', color = '#efefef', isVisible = true, margin = '0' }) => `
    display: ${isVisible ? 'block' : 'none'};
    height: ${height};
    background-color: ${color};
    margin: ${margin};
  `};
`;

export default Divider;
